// extracted by mini-css-extract-plugin
export default {"DropdownCity":"DropdownCity_DropdownCity__ohfvi"};